import React from 'react'
import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import {
  osName,
} from 'react-device-detect'
import {
  WarrantyTableCoilIdWrapper
} from './styled'
import {
  Section,
  Text,
  Image,
  Grid,
  Table,
  ShapeContainer,
} from './../../../../components'
import {
  VARIABLES,
} from './../../../../themes'

/**
 * Warranty description:
 * - Warranty
 */

export class WarrantyBSWMThailandTableCoilId extends React.PureComponent {
  render() {
    const {
      children,
      thLanguage,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-table-coil-id',
    )

    return (
      <WarrantyTableCoilIdWrapper
        className={classes}
      >
        <Table fluid warranty>
          <Table.Section>
            <Table.Row>
              <Table.Column className='is-head-column' alignCenter maxWidth='50' minWidth='50' paddingVertical='4' paddingHorizontal='4'>
                <p className='warranty-bswm-text is-sm'>{thLanguage ? 'เลขที่' : 'No.'}</p>
              </Table.Column>
              <Table.Column className='is-head-column' alignCenter maxWidth='400' minWidth='400' paddingVertical='4' paddingHorizontal='4'>
                <p className='warranty-bswm-text is-sm'>{thLanguage ? 'รายละเอียดเบอร์คอยล์' : 'Description Coil ID'}</p>
              </Table.Column>
              <Table.Column className='is-head-column' alignCenter maxWidth='240' minWidth='240' paddingVertical='4' paddingHorizontal='4'>
                <p className='warranty-bswm-text is-sm'>{thLanguage ? 'เบอร์คอยล์' : 'Coil ID'}</p>
              </Table.Column>
            </Table.Row>
          </Table.Section>
          {children}
        </Table>
      </WarrantyTableCoilIdWrapper>
    )
  }

  static defaultProps = {
    // If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
